import { ICourseRefershTokenResponse } from '@ninjacart/nc-nk-core';
import paths from '../paths';
import { CourseClient } from './courseClient';

export const getCourseRefreshToken = async (payload) => {
  try {
    const response = await CourseClient.get<ICourseRefershTokenResponse>(
      paths.getCourseRefershUrl(payload)
    );
    return response.data;
  } catch (e) {
    throw e;
  }
};
